import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../store/useApp';
import { Loading } from './ui';

export function RequireAuth({ children }) {
  const { session, cargandoSesion, cargandoTenants, tenantActivo } = useApp();
  const loc = useLocation();
  if (cargandoSesion) return <Loading />;
  if (!session) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  // Ventana entre iniciar sesión y cargar los tenants: espera en vez de rebotar a /login.
  if (!tenantActivo) {
    if (cargandoTenants) return <Loading />;
    return <Navigate to="/login" replace />;
  }
  return children;
}

export function RequireSession({ children }) {
  const { session, cargandoSesion } = useApp();
  const loc = useLocation();
  if (cargandoSesion) return <Loading />;
  if (!session) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

export function RequireRole({ roles, children }) {
  const { tenantActivo } = useApp();
  const rol = tenantActivo?.rol;
  if (!roles.includes(rol)) return <Navigate to="/" replace />;
  return children;
}
